import { type ReactNode } from 'react'
import { usePushNotifications } from '@/hooks/usePushNotifications'

interface PushNotificationProviderProps {
  children: ReactNode
}

/**
 * Provider component that initializes push notifications when user is authenticated.
 * Wrap your app with this component to enable automatic push notification registration.
 */
export function PushNotificationProvider({ children }: PushNotificationProviderProps) {
  // Initialize push notifications hook
  usePushNotifications()

  return <>{children}</>
}
